import styled, { css } from 'styled-components'
import { Media } from 'builder/styles/media'
import { Button } from 'builder/components/Button'

export const FormContainer = styled.form`
  width: 100%;
`

export const RowContainer = styled.div<{ position?: string }>`
  ${props =>
    props.position &&
    css`
      position: ${props.position || 'static'};
    `}

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`

export const RowsContainer = styled.div`
  width: 100%;
`

type ButtonsContainerProps = {
  signUpFlow: string | undefined
  singleSignFlow: boolean
}
export const ButtonsContainer = styled.div<ButtonsContainerProps>(
  ({ signUpFlow, singleSignFlow }) => {
    let marginTop: number | undefined

    if (signUpFlow) marginTop = 28
    if (singleSignFlow) marginTop = 0

    return css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: ${marginTop !== undefined ? marginTop : 48}px;
      margin-bottom: ${singleSignFlow && '12px'};

      ${Media.Phone`
        margin-top: 32px;
      `};

      & ${Button}:last-child {
        margin-left: auto;
      }
    `
  },
)

export const Spacer = styled.div`
  flex: 1;
`
export const BottomContainer = styled.div`
  padding-top: 10px;
`

export const WrapperProcessIndicator = styled.div`
  margin-top: 32px;

  ${Media.Phone`
    margin-top: 24px;
  `};
`
